import styled from "styled-components";

export const SeccondModalButtons = styled.div`
  margin-top: 1rem;
  display: flex;
  justify-content: flex-end;
`;

export const BackIcon = styled.span`
  display: flex;
  justify-content: flex-end;
  margin: 1rem 1rem 0 0;
`;